export const cutText = (text, number = 25) => {
  if (text && text.length > number) {
    return `${text.slice(0, Math.ceil(number - 3))} ...`;
  }
  return text;
};
